import PageErrorBoundary from './components/PageErrorBoundary';

// see comment at
// edrolo/domains/app/components/PageErrorBoundary/PageErrorBoundary.jsx
export const pageErrorBoundaryHoc = (Page) => {
  return (props) => (
    <PageErrorBoundary>
      <Page {...props} />
    </PageErrorBoundary>
  );
};
